import Loader from "components/Loader";
import Text from "components/Text";
import {
    CountsWrapper,
    Header,
    HeaderText,
} from "pages/FindTalent/FindTalent.styled";
import { NoDataContentCenter } from "pages/Job/MyJobListings/MyJobListings.styled";
import { useEffect } from "react";
import { useAppSelector } from "slice";
import {
    useGetJobsListingMutation,
    useGetLikedJobsListingQuery,
} from "slice/jobs";
import { JobDetails, VotableType } from "slice/jobs/types";
import theme from "theme";
import { CardsColumn, FindWorkWrapper, RightSection } from "./FindWork.styled";
import FindWorkCard from "./FindWorkCard";
type FindWorkProps = {
    type: string;
};
export const FindWork = ({ type }: FindWorkProps) => {
    const { id: userId } = useAppSelector((state) => state.user);
    const [getJobsListing, { data: jobsList, isLoading: isFetching }] =
        useGetJobsListingMutation();

    const { data: jobsLikedList, refetch } = useGetLikedJobsListingQuery({
        user_id: userId ?? "",
    });
    useEffect(() => {
        if (type !== "liked")
            getJobsListing({ user_id: userId || "", job_type: type });
        if (type === "liked") {
            refetch();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userId, type]);

    return (
        <FindWorkWrapper>
            {/* <FilterBar /> */}
            <RightSection>
                {isFetching && <Loader size={28} />}
                <Header>
                    <HeaderText>
                        <Text
                            variant="heading5"
                            fontWeight="700"
                            color={theme.colors.text}
                        >
                            Find Work
                        </Text>
                        <CountsWrapper>
                            {type !== "liked" && (
                                <Text
                                    variant="label"
                                    color={theme.colors.green.primary}
                                >
                                    {jobsList?.count} Matching
                                </Text>
                            )}
                            {type === "liked" && (
                                <Text
                                    variant="label"
                                    color={theme.colors.green.primary}
                                >
                                    {jobsLikedList?.count} Matching
                                </Text>
                            )}
                            <Text
                                className="resultsText"
                                variant="label"
                                color={theme.colors.text}
                            >
                                call opportunities
                            </Text>
                        </CountsWrapper>
                    </HeaderText>
                    {/* <SingleSelect
                        label="Sort By"
                        value="Relevance"
                        options={[
                            {
                                label: "Relevance",
                                value: "Relevance",
                            },
                            {
                                label: "Most Recent",
                                value: "Most Recent",
                            },
                        ]}
                        placeholder="Relevance"
                    /> */}
                </Header>
                {type !== "liked" && (
                    <CardsColumn>
                        {jobsList && jobsList.jobs.length > 0 ? (
                            jobsList?.jobs.map((job: JobDetails) => {
                                return (
                                    <FindWorkCard
                                        key={job.id}
                                        job={job}
                                        type={type}
                                    />
                                );
                            })
                        ) : (
                            <NoDataContentCenter>
                                <Text variant="heading3">No Data Found.</Text>
                            </NoDataContentCenter>
                        )}
                    </CardsColumn>
                )}
                {type === "liked" && (
                    <CardsColumn>
                        {jobsLikedList &&
                        (jobsLikedList?.likes || []).length > 0 ? (
                            (jobsLikedList?.likes || []).map(
                                (job: VotableType) => {
                                    return (
                                        <FindWorkCard
                                            key={job.id}
                                            job={job.votable_details}
                                            type={type}
                                        />
                                    );
                                }
                            )
                        ) : (
                            <NoDataContentCenter>
                                <Text variant="heading3">No Data Found.</Text>
                            </NoDataContentCenter>
                        )}
                    </CardsColumn>
                )}
            </RightSection>
        </FindWorkWrapper>
    );
};
